import { Translation } from 'hooks/useTranslation/useTranslation';
import { useMemo } from 'react';
import { DeviceGroupRow } from 'v2/hooks/useDeviceGroups/useDeviceGroups';
import { useSearch } from './useSearch';

const searchKeys = ['name', 'doors.name', 'hasNoDevices', 'hasNoUserGroups', 'userGroups.name', 'accessStatus'];

export function useDeviceGroupSearch({
  deviceGroups,
  search,
  translation
}: {
  deviceGroups: DeviceGroupRow[];
  search: string;
  translation: Translation;
}): DeviceGroupRow[] {
  const searchableGroups = useMemo(
    () =>
      deviceGroups.map((group) => ({
        ...group,
        hasNoDevices: (group.doors ?? []).length === 0 ? translation.no_devices : '',
        hasNoUserGroups: group.userGroups.length === 0 ? translation.no_user_groups : '',
        accessStatus:
          (group.doors ?? []).length > 0 && group.userGroups.length > 0 ? translation.complete : translation.incomplete
      })),
    [deviceGroups, translation]
  );

  const matchedSearchable = useSearch({ data: searchableGroups, search, keys: searchKeys });

  return useMemo(
    () => matchedSearchable.map(({ hasNoDevices, hasNoUserGroups, accessStatus, ...group }) => group),
    [matchedSearchable]
  );
}
